/* eslint-disable no-loop-func */
import '../../../styles/schedule.scss';
import React, { Component } from 'react';
import { DatePicker, Picker, Modal, Tag, Icon, Toast } from 'antd-mobile';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from 'react-router';
import { queryWeekList, querySectionList } from '../../../services/saas/schedule';
import { getUser } from '../../../utils';
import {
  tree as querySchool,
  treeByAuthority as queryAuthSchool,
} from '../../../services/saas/dept';
import { list as queryLesson } from '../../../services/saas/conference';
import { rooms as queryRoom } from '../../../services/saas/room';
import sysConfig from '@/sysConfig';
const { preRouteUrl } = sysConfig;

const DatePickerChildren = ({ onClick, extra }) => (
  <div onClick={onClick} className="date text-overflow">
    {moment(extra).format('YYYY-MM-DD')}
  </div>
);

const DeptPickerChildren = ({ onClick, extra }) => (
  <div onClick={onClick} className="dept picker-container">
    <span className="text-overflow">{extra}</span>
    <Icon type="down" />
  </div>
);

const RoomPickerChildren = ({ onClick, extra }) => (
  <div onClick={onClick} className="room picker-container">
    <span className="text-overflow">{extra}</span>
    <Icon type="down" />
  </div>
);

const TemplatePickerChildren = ({ onClick, extra }) => {
  return (
    <div onClick={onClick} className="template picker-container">
      <span className="text-overflow">{extra}</span>
      <Icon type="down" />
    </div>
  );
};

function coordTreeMap(tree) {
  const map = [];
  const flatMap = (data) => {
    data.forEach((item) => {
      const newItem = {
        label: item.title,
        value: item.value,
      };
      map.push(newItem);
      if (item.children) {
        flatMap(item.children);
      }
    });
  };
  flatMap(tree);
  return map;
}

class Schedule extends Component {
  state = {
    date: moment().toDate(),
    depts: [],
    deptsLeveL: 1,
    rooms: [],
    sectionTemplateList: [],
    sectionTemplateMap: {},
    sectionTemplate: {},
    sectionList: [],
    weeks: [],
    lessons: {},
  };

  componentDidMount() {
    this.init();
  }

  init = async () => {
    const { date } = this.state;
    const { userType, deptId } = getUser() || {};
    const [schoolId] = deptId.split(',');
    const respSchool = userType === '5' ? await querySchool() : await queryAuthSchool();
    const state = {
      dept: [schoolId],
    };
    if (respSchool.success) {
      state.depts = coordTreeMap(respSchool.data);
    }
    const respRooms = await queryRoom({ deptId: schoolId });
    if (respRooms.success) {
      state.rooms = respRooms.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }
    await this.setState(state);
    this.querySectionTemplate([schoolId], moment(date), () => {
      this.getWeeks(moment(date));
    });
  };

  nextWeek = async () => {
    const { date, dept } = this.state;
    const newDate = moment(date).add(7, 'days');
    this.querySectionTemplate(dept, newDate, () => {
      this.getWeeks(newDate);
    });
  };

  prevWeek = async () => {
    const { date, dept } = this.state;
    const newDate = moment(date).add(-7, 'days');
    this.querySectionTemplate(dept, newDate, () => {
      this.getWeeks(newDate);
    });
  };

  deptChange = async (value) => {
    let rooms = [];
    const { date } = this.state;
    const [deptId] = value;
    const respRooms = await queryRoom({ deptId });
    if (respRooms.success) {
      rooms = respRooms.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }
    this.setState({
      dept: value,
      rooms,
    });
    this.querySectionTemplate(deptId, moment(date), () => {
      this.getWeeks(moment(date));
    });
  };

  roomChange = async (value) => {
    const roomId = _.last(value);
    if (!roomId) {
      this.setState({});
    }
    await this.setState({ room: value });
    this.refreshTable();
  };

  getWeeks = async (date) => {
    Toast.loading('加载中', 0);
    const { userType, userId } = getUser() || {};
    const {
      // sectionTemplate: { start: sectionStart, end: sectionEnd },
      room,
      dept,
    } = this.state;
    let start = moment(date)
      .add(1 - (date.day() || 7), 'days')
      .format('YYYY-MM-DD');
    // if (moment(sectionStart).isBetween(moment(start), moment(start).add(7, 'days'))) {
    //   start = sectionStart;
    // }
    const weekMap = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    const weekList = [];
    const lessonMap = {};
    // const sjc = sectionEnd ? moment(sectionEnd).diff(moment(start), 'days') + 1 : 7;
    // const max = sjc < 7 ? sjc : 7;
    const max = 7;
    for (let i = 0; i < max; i++) {
      let week = moment(start).add(i, 'days');
      weekList.push({
        key: week.valueOf(),
        weekName: weekMap[week.day() || 7],
        dateName: week.format('MM-DD'),
        date: week,
      });
      if (week.day() === 0) {
        break;
      }
    }
    const end = _.last(weekList).date;
    if (room || userType === '1') {
      const payload = {
        size: '-1',
        sceneCode: '1,2',
        scheduledStartTimeBeginDate: weekList[0].date.format('YYYY-MM-DD'),
        scheduledStartTimeEndDate: end.format('YYYY-MM-DD'),
        deptId: _.last(dept),
        memberId: _.last(room),
      };
      if (userType === '1') {
        payload.lecturerId = userId;
      }
      const respLesson = await queryLesson(payload);
      if (respLesson.success) {
        respLesson.data.records.forEach((item) => {
          if (!lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`]) {
            lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`] = [];
          }
          lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`].push({
            lessonId: item.id,
            lessonName: item.name,
            sectionId: item.sectionId,
            start: item.scheduledStartTime,
            end: item.scheduledEndTime,
            status: item.conferenceStatus,
            tags: item.conferenceAttributeDetailList.map((attrItem) => ({
              title: attrItem.attributeValueName,
              key: attrItem.detailId,
            })),
            deptName: item.deptName,
            memberName: item.memberName,
            isLive: item.liveRecordInfo.autoPlatlive === 1,
            typeCode: item.typeCode,
            profileName: item.profileName,
            lecturerName: item.teachInfo.lecturerName || '',
          });
        });
      }
    }
    await this.setState({
      date: date.toDate(),
      weeks: weekList,
      lessons: lessonMap,
    });
    setTimeout(() => Toast.hide(), 300);
  };

  querySectionTemplate = async ([deptId], queryDate, callback) => {
    const state = {};
    const respTemp = await queryWeekList({
      orgId: deptId,
      queryDate: queryDate.format('YYYY-MM-DD'),
    });
    if (respTemp.success && respTemp.data.length > 0) {
      const respSection = await querySectionList({ templateId: respTemp.data[0].templateId });
      if (respSection.success) {
        const sectionTemplateMap = {};
        const sectionMap = {};
        respSection.data.forEach((item) => {
          sectionMap[item.detailId] = {
            text: item.sectionDictName,
            value: item.detailId,
            start: item.startTime,
            end: item.endTime,
          };
        });
        state.sectionTemplateList = respTemp.data.map((item) => {
          sectionTemplateMap[item.templateId] = {
            start: item.startDate,
            end: item.endDate,
          };
          return {
            label: item.templateName,
            value: item.templateId,
          };
        });
        state.sectionTemplateMap = sectionTemplateMap;
        state.sectionTemplate = {
          id: respTemp.data[0].templateId,
          start: respTemp.data[0].endDate,
          end: respTemp.data[0].endDate,
        };
        state.sectionList = sectionMap;
        await this.setState(state);
        if (callback) {
          callback();
        }
      }
    }
  };

  refreshTable = async () => {
    const { userType, userId } = getUser() || {};
    const { weeks, dept, room } = this.state;
    if (room || userType === '1') {
      Toast.loading('加载中', 0);
      const lessonMap = {};
      const payload = {
        size: '-1',
        sceneCode: '1,2',
        scheduledStartTimeBeginDate: weeks[0].date.format('YYYY-MM-DD'),
        scheduledStartTimeEndDate: _.last(weeks).date.format('YYYY-MM-DD'),
        deptId: _.last(dept),
        memberId: _.last(room),
      };
      if (userType === '1') {
        payload.lecturerId = userId;
      }
      const respLesson = await queryLesson(payload);
      if (respLesson.success) {
        respLesson.data.records.forEach((item) => {
          if (!lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`]) {
            lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`] = [];
          }
          lessonMap[`${moment(item.scheduledStartTime).format('MM-DD')}-${item.sectionId}`].push({
            lessonId: item.id,
            lessonName: item.name,
            sectionId: item.sectionId,
            start: item.scheduledStartTime,
            end: item.scheduledEndTime,
            status: item.conferenceStatus,
            tags: item.conferenceAttributeDetailList.map((attrItem) => ({
              title: attrItem.attributeValueName,
              key: attrItem.detailId,
            })),
            deptName: item.deptName,
            memberName: item.memberName,
            isLive: item.liveRecordInfo.autoPlatlive === 1,
            typeCode: item.typeCode,
            profileName: item.profileName,
            lecturerName: item.teachInfo.lecturerName || '',
          });
        });
        await this.setState({
          lessons: lessonMap,
        });
        setTimeout(() => Toast.hide(), 300);
      }
    }
  };

  coordSchedule = () => {
    const { weeks, sectionList, lessons } = this.state;
    const { history } = this.props;
    const trs = [];
    const sectionKey = Object.keys(sectionList);
    const lessonStatus = ['will', 'ing', 'end'];
    for (let i = 0; i < sectionKey.length; i++) {
      trs.push(
        <div className="row" key={sectionKey[i]}>
          {weeks.map((item) => {
            const lesson = lessons[`${item.dateName}-${sectionKey[i]}`];
            if (lesson && lesson.length > 0) {
              let lessonItem;
              const will = [],
                ing = [],
                end = [];
              lesson.forEach((course) => {
                if (course.status === '0') {
                  will.push(course);
                }
                if (course.status === '1') {
                  ing.push(course);
                }
                if (course.status === '2') {
                  end.push(course);
                }
              });
              if (end.length > 0) {
                if (end.length > 1) {
                  end.sort((a, b) => moment(b).valueOf() - moment(a).valueOf());
                }
                lessonItem = end[0];
              }
              if (will.length > 0) {
                lessonItem = will[0];
              }
              if (ing.length > 0) {
                lessonItem = ing[0];
              }
              return (
                <div key={lessonItem.lessonId} className="column">
                  <div
                    className={`schedule-item ${lessonStatus[lessonItem.status]}`}
                    onClick={() => {
                      const acitons = [];
                      if (lessonItem.status === '1') {
                        acitons.push({
                          text: '进入课堂',
                          onPress: () => {
                            history.push(
                              `${preRouteUrl}/livePlay/conference/${lessonItem.lessonId}`,
                            );
                          },
                        });
                      }
                      acitons.push({
                        text: '关闭',
                        onPress: () => {
                          this.modal.close();
                        },
                      });
                      this.modal = Modal.alert(
                        lessonItem.lessonName,
                        <div style={{ textAlign: 'left', padding: '0 2vw' }}>
                          <p>
                            标签：
                            {lessonItem.tags.map((attrTag) => (
                              <Tag key={attrTag.key} selected style={{ margin: '0 5px 8px' }}>
                                {attrTag.title}
                              </Tag>
                            ))}
                          </p>
                          <p>
                            主讲学校：
                            {lessonItem.deptName}
                          </p>
                          <p>
                            主讲教室：
                            {lessonItem.memberName}
                          </p>
                          <p>
                            主讲人：
                            {lessonItem.lecturerName || ''}
                          </p>
                          <p>
                            模板：
                            {lessonItem.profileName || ''}
                          </p>
                        </div>,
                        acitons,
                      );
                    }}
                  >
                    <span>{lessonItem.lessonName}</span>
                  </div>
                </div>
              );
            } else if (
              moment(
                `${item.date.format('YYYY-MM-DD')} ${sectionList[sectionKey[i]].end}`,
              ).isBefore(moment())
            ) {
              return <div className="column" key={`${sectionKey[i]}_${item.key}`} />;
            } else {
              return <div className="column" key={`${sectionKey[i]}_${item.key}`} />;
            }
          })}
        </div>,
      );
    }
    return trs;
  };

  sectionTemplateChange = async ([templateId]) => {
    const { date, sectionTemplateMap } = this.state;
    const respSection = await querySectionList({ templateId: templateId });
    const sectionMap = {};
    respSection.data.forEach((item) => {
      sectionMap[item.detailId] = {
        text: item.sectionDictName,
        value: item.detailId,
        start: item.startTime,
        end: item.endTime,
      };
    });
    if (respSection.success) {
      await this.setState({
        sectionTemplate: {
          start: sectionTemplateMap[templateId].start,
          end: sectionTemplateMap[templateId].end,
          id: templateId,
        },
        sectionList: sectionMap,
      });
      this.getWeeks(moment(date));
    }
  };

  render() {
    const {
      depts,
      dept,
      deptsLeveL,
      weeks,
      rooms,
      room,
      sectionList,
      date,
      sectionTemplateList,
      sectionTemplate,
    } = this.state;
    const { userType, deptId } = getUser() || {};
    const relactionMutiple = deptId.split(',').length > 1;
    return (
      <div className="schedule">
        <div className="schedule-filters">
          {sectionTemplateList.length > 1 ? (
            <Picker
              data={sectionTemplateList}
              value={[sectionTemplate.id]}
              cols={1}
              onOk={this.sectionTemplateChange}
              extra="课节模板"
            >
              <TemplatePickerChildren />
            </Picker>
          ) : null}
          {userType === '5' || relactionMutiple ? (
            <Picker data={depts} value={dept} cols={deptsLeveL} onOk={this.deptChange} extra="学校">
              <DeptPickerChildren />
            </Picker>
          ) : null}
          {'5,6'.indexOf(userType) > -1 || relactionMutiple ? (
            <Picker data={rooms} value={room} cols={1} onOk={this.roomChange} extra="教室">
              <RoomPickerChildren />
            </Picker>
          ) : null}
        </div>
        <div className="schedule-control-bar">
          <div>
            <button className="preWeek" onClick={this.prevWeek}>
              上一周
            </button>
          </div>
          <DatePicker
            mode="date"
            format="YYYY-MM-DD"
            value={date}
            onChange={(date) => {
              const { dept } = this.state;
              this.querySectionTemplate(dept, moment(date), () => {
                this.getWeeks(moment(date));
              });
            }}
            extra={date}
          >
            <DatePickerChildren />
          </DatePicker>
          <div>
            <button className="nextWeek" onClick={this.nextWeek}>
              下一周
            </button>
          </div>
        </div>
        <div className="schedule-table">
          <div className="schedule-table-coner">
            <span>星期</span>
            <span>课节</span>
          </div>
          <ul className="schedule-table-head">
            {weeks.map((item) => (
              <li key={item.key}>
                <div className="week">{item.weekName}</div>
                <div className="day">{item.dateName}</div>
              </li>
            ))}
          </ul>
          <div style={{ width: '100%' }}>
            <ul className="schedule-table-section">
              {Object.keys(sectionList).map((item) => (
                <li key={item}>{sectionList[item].text}</li>
              ))}
            </ul>
            <div className="schedule-table-content">{this.coordSchedule()}</div>
          </div>
        </div>
        <div className="schedule-legend">
          <span className="label">课程状态：&nbsp;&nbsp;</span>
          <span>
            <em className="will" />
            未开始
          </span>
          <span>
            <em className="ing" />
            进行中
          </span>
          <span>
            <em className="end" />
            已结束
          </span>
        </div>
      </div>
    );
  }
}

export default withRouter(Schedule);
